import { space } from './strings.js';
import { generateKey } from './keys.js';
import { replaceAll } from './patterns.js';
const whiteSpaces = /\r?\n\s*/g;
const idMatcher = /id="([^"]+)"/g;
export function svgStrip(content) {
    return content.replace(whiteSpaces, space).trim();
}
export function svgProcess(content) {
    return randomId(svgStrip(content));
}
export function randomId(content) {
    let match;
    while ((match = idMatcher.exec(content))) {
        const [, id] = match;
        const newId = generateKey();
        content = content.replace(`id="${id}"`, `id="${newId}"`);
        content = replaceAll(content, `xlink:href="#${id}"`, `xlink:href="#${newId}"`);
        content = replaceAll(content, `"url(#${id})"`, `"url(#${newId})"`);
    }
    return content;
}
//# sourceMappingURL=svg.js.map